import { graphqlApolloClient } from "../graphql-apollo-client"
import { GET_PROJECT_BENEFICIARIES_WITH_ATTENDANCE } from "./graphql/queries/get-project-beneficiaries-with-attendance"

export const getProjectBeneficiariesWithAttendance = async ({ submissionId }) => {
  const { data } = await graphqlApolloClient.query({
    query: GET_PROJECT_BENEFICIARIES_WITH_ATTENDANCE,
    fetchPolicy: "network-only",
    variables: {
      submissionId
    }
  })

  return data?.ProjectBeneficiariesWithAttendance || []
}